// Accès aux pages du portail selon les permissions RBAC.
// Une page s'ouvre si la personne a au moins une des permissions listées.

export const PAGE_ACCESS = {
  '/dashboard/service-requests': ['service_requests.view'],
  '/dashboard/quotes': ['quotes.view', 'cleaning_requests.view', 'part_orders.view'],
  '/dashboard/projects': ['projects.view'],
  '/dashboard/inventory': ['inventory.read'],
  '/dashboard/billable-materials': ['billing.materials.read'],
  '/dashboard/purchase-orders': ['purchase_orders.read'],
  '/dashboard/equipment': ['equipment.view', 'replacement_requests.create', 'replacement_requests.manage', 'material_orders.manage'],
  '/dashboard/employees': ['employees.view', 'employees.create', 'employees.edit'],
  '/dashboard/time-entries': ['time_entries.view', 'time_entries.create'],
  '/dashboard/leave-requests': ['leave_requests.view', 'leave_requests.create', 'leave_requests.approve'],
};

export const canOpen = (can, path) => {
  const permissions = PAGE_ACCESS[path];
  return !permissions || permissions.some((permission) => can(permission));
};

// Libellé « Mes … » quand la personne ne voit que ses propres dossiers.
export const navLabel = (item, scopeOf, can) => {
  if (!item.ownName) return item.name;
  if (item.path === '/dashboard/leave-requests') {
    return can('leave_requests.approve') || scopeOf('leave_requests.view') === 'all' ? item.name : item.ownName;
  }
  return scopeOf(item.ownPermission) === 'own' ? item.ownName : item.name;
};
